const getAuth0ErrorCode = (errorString) => {
  const regex = /"auth0ErrorCode":"(\w+)"/;
  const result = regex.exec(errorString);
  return result && result[1] ? result[1] : void 0;
};
export {
  getAuth0ErrorCode
};
//# sourceMappingURL=get-auth0-error-code.js.map
